var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "bottom-buttons": !_vm.top } }, [
    _c(
      "div",
      {
        staticClass: "row",
        staticStyle: { "margin-top": "50px", "margin-bottom": "50px" }
      },
      [
        !_vm.top
          ? _c(
              "button",
              {
                staticStyle: {
                  background: "none",
                  border: "none",
                  margin: "auto",
                  display: "block"
                },
                attrs: { type: "submit", tag: "a" }
              },
              [_vm._m(0)]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn btn-create btn-save" }, [
      _c("i", { staticClass: "fa fa-save" }),
      _vm._v("  Save\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5010a15e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5010a15e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/saveButton.vue
// module id = 209
// module chunks = 0